import { render, staticRenderFns } from "./add-official-policy.vue?vue&type=template&id=2c860f5c&scoped=true&"
import script from "./add-official-policy.vue?vue&type=script&lang=js&"
export * from "./add-official-policy.vue?vue&type=script&lang=js&"
import style0 from "./add-official-policy.vue?vue&type=style&index=0&id=2c860f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c860f5c",
  null
  
)

export default component.exports